import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import BlogCard from "./BlogCard";
import logoImage from "./../../assets/ayushi_log.6e5fc2d9bf89245e0c93.png";
// import { Link, useNavigate } from "react-router-dom";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(
          "https://ayushiconstruction.com/api/blogs/allBlogs",
        );
        setBlogs(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError("Failed to load blogs");
        setLoading(false);
      }
    };

    fetchBlogs();
    window.scrollTo(0, 0);
  }, []);

  const handleFooterLink = () => {
    window.scrollTo(0, 0);
  };

  if (loading)
    return (
      <>
        {/* <Finalnav /> */}
        <div className="cs_height_90 cs_height_lg_90"></div>
        <Container>
          <div className="container py-5 text-center">
            <h3 className="loader">Loading blogs...</h3>
          </div>
        </Container>
      </>
    );

  if (error)
    return (
      <>
        {/* <Finalnav /> */}
        <div className="cs_height_90 cs_height_lg_90"></div>
        <Container>
          <div className="container py-5 text-center">
            <h3 className="error">{error}</h3>
            <button
              type="button"
              className="btn mt-4"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        </Container>
      </>
    );
  return (
    <>
      <Container>
        <div className="container" id="about">
          <div className="heading text-center">
            <h1>Welcome to Ayushi Construction Blogs Page</h1>
            <div
              className="underline mx-auto"
              style={{
                height: 3,
                width: "4rem",
                backgroundColor: "#34495E",
                marginTop: 20,
                marginBottom: 20,
              }}
            ></div>
          </div>
          <div className="row mt-5 cardBox">
            {blogs.length > 0 ? (
              blogs.map((blog, index) => (
                <BlogCard
                  key={blog.id}
                  title={blog.title}
                  description={
                    blog.excerpt || "Open the article to read the full content."
                  }
                  link={`/blogslist/${blog.slug}`}
                  image={`https://ayushiconstruction.com/public/uploads/${blog.image_url}`}
                  imageAlt={blog.image_alt_text || blog.title}
                  date={
                    blog.published_date && !isNaN(new Date(blog.published_date))
                      ? new Date(blog.published_date).toLocaleDateString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )
                      : "Date not available"
                  }
                  handleFooterLink={handleFooterLink}
                />
              ))
            ) : (
              <div className="col-12 text-center py-5">
                <h4>No New blogs found</h4>
                <p>Check back later for new content!</p>
              </div>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export default BlogPage;
const Container = styled.div`
  .loader,
  .error {
    text-align: center;
    padding: 2rem;
    font-size: 1.2rem;
    color: #5a626d;
  }

  #about {
    margin-top: 2.5rem;
    @media screen and (max-width: 768px) {
      margin-top: 1rem;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      margin-top: 1rem;
    }
  }
`;
